import script from "./RootsAndAffixes.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootsAndAffixes.vue?vue&type=script&setup=true&lang=ts"

import "./RootsAndAffixes.vue?vue&type=style&index=0&id=21d101af&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d101af"]])

export default __exports__